// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2EFH2","signatureButtonsRight":"ModalSign_signatureButtonsRight__RfRD_"};